var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filters-header d-flex"},[_c('h2',{staticClass:"mr-3"},[_vm._v("Filters")]),(_vm.counter)?_c('v-chip',{attrs:{"x-small":"","pill":"","color":"red","text-color":"white"}},[_vm._v(_vm._s(_vm.counter))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }